import React, {Component} from 'react';
import AdminTabs from './AdminTabs';
import {DataTable} from "react-data-components";
import jwt from 'jsonwebtoken';
import moment from 'moment';
import SelectSearch from 'react-select-search';

import { WithContext as ReactTags } from 'react-tag-input';


function buildTable(data, columns) {
  const renderMapUrl =
    (val, row) =>
      <a href={`https://www.google.com/maps?q=${row['lat']},${row['long']}`}>
        Google Maps
      </a>;

  return (
    <DataTable
        keys="name"
        className="table-striped table"
        columns={columns}
        initialData={data}
        useShowHideColumns={true}
        initialPageLength={10}
        initialSortBy={{ prop: 'name', order: 'descending' }}
        pageLengthOptions={[10, 25, 50, 100]}
    />
  );
}


const KeyCodes = {
  comma: 188,
  enter: 13,
};
 
const delimiters = [KeyCodes.comma, KeyCodes.enter];


class AdminAnnouncementsView extends Component {
    
    constructor(props){
        super(props);
        
        this.state = {
            loaded: false,
            announcementTitle: '',
            announcementContent: '',
            announcementDate: new Date(),
            createAnnouncement: false,
            sendingToCourse: [],
            sendingToPeople: [],
            sendToAll: true,
            sendToCourse: false,
            sendToPeople: false,
            showSendToCourse: true,
            showSendToPeople: false,
            displaySelectOptions: false
        }
    }
    
    sendAnnouncement = () => {
        let command = jwt.sign({
                    command: {
                        type: 'ADD_ANNOUNCEMENT',
                        announcement: {
                            title: this.state.announcementTitle,
                            content: this.state.announcementContent,
                            profileId: this.props.user.user.Profile.id,
                            date: this.state.announcementDate,
                            courses: this.state.sendingToCourse.map(c => c.id),
                            people: this.state.sendingToPeople.map(p => p.id)
                        },
                        profileId: this.props.user.user.Profile.id,
                        token: this.props.user.id
                    }}, '#&r7%+UbWU8Hc');
                    
                    this.props.socket.send(command);
                    this.setState({
                        announcementTitle: '',
                        announcementContent: '',
                        createAnnouncement: false,
                        sendToAll: true,
                        sendToCourse: false,
                        sendToPeople: false
                    })
    }
    
    
    componentDidMount = () => {
        try{
        let command = jwt.sign({
            command: {
                type: 'GET_ANOUNCEMENTS',
                profileId: this.props.user.user.Profile.id,
                token: this.props.user.id
            }}, '#&r7%+UbWU8Hc');
            if(this.props.socket){
                this.props.socket.send(command);
            }
        }catch(err){
        }
    }
    
    componentDidUpdate = (props) => {
        if(this.props.socket.readyState && !this.state.loaded){
            
            this.setState({loaded: true}, () => {
                let command = jwt.sign({
                    command: {
                        type: 'GET_ANOUNCEMENTS',
                        profileId: this.props.user.user.Profile.id,
                        token: this.props.user.id
                    }}, '#&r7%+UbWU8Hc');
                    
                    this.props.socket.send(command);
            })
            
            
            
        }
        
        if(props.flaggedComments !== this.props.flaggedComments){
            //buildTable(this.props.flaggedComments);
        }
        
    }
    
    deleteAnnouncement = (announcement) => {
        let command = jwt.sign({
                    command: {
                        type: 'DELETE_ANOUNCEMENT',
                        id: announcement.id,
                        threadId: announcement.threadId,
                        profileId: this.props.user.user.Profile.id,
                        token: this.props.user.id
                    }}, '#&r7%+UbWU8Hc');
                    if(this.props.socket.readyState){
                        this.props.socket.send(command);
                    }
    }
    
    renderAnnouncement = (val, row) => {
        return (
            <div>

                <p>{row.title}</p>
                <p style={{color: "#8a8a8a"}}>{row.content}</p>
                                                
            </div>
        )
    }
    
    renderDate = (val, row) => {
        return (
            <span>{moment(val).format('MMM DD YYYY')}</span>
        )
    }
    
    renderSentTo = (val, row) => {
        return (
            <span>AN</span>
        )
    }
    
    renderStatus = (val, row) => {
        return (
            <span>{(moment().diff(moment(val), 'seconds') > 0) ? <span className="label label-danger">Past</span> : <span className="label label-info">Upcoming</span>}</span>
        )
    }
    
    renderOptions = (val, row) => {
        return (
            <span>
                <a href="#nogo" title="" className="btn btn-icon btn-default" data-original-title="Delete Announcement" onClick={e => this.deleteAnnouncement(row)}><i className="zmdi zmdi-close"></i> </a>
            </span>
        )
    }
    
    renderCourseSelector1 = () => {
        const options = [
            {name: 'Swedish', value: 'sv'},
            {name: 'English', value: 'en'},
            {
                type: 'group',
                name: 'Group name',
                items: [
                    {name: 'Spanish', value: 'es'},
                ]
            }
        ];
         
        /* Simple example */
        return (
            <SelectSearch
                options={options}
                value={[]}
                name="language"
                placeholder="Choose courses"
                multiple={true}
                onFocus={e => this.setState({displaySelectOptions: true})}
                onBlur={e => this.setState({displaySelectOptions: false})}
                displaySelectOptions={this.state.displaySelectOptions}
                
                
                />
        )
    }
    
    renderPeopleSelector1 = () => {
        const options = [
            {name: 'Swedish', value: 'sv'},
            {name: 'English', value: 'en'},
            {
                type: 'group',
                name: 'Group name',
                items: [
                    {name: 'Spanish', value: 'es'},
                ]
            }
        ];
         
        /* Simple example */
         return (
            <SelectSearch
                options={options}
                value={[]}
                name="language"
                placeholder="Choose courses"
                multiple={true}
                onFocus={e => this.setState({displaySelectOptions: true})}
                onBlur={e => this.setState({displaySelectOptions: false})}
                displaySelectOptions={this.state.displaySelectOptions}
               
                
                />
        )
    }
    
    renderCourseSelector = () => {
        return (
            <ReactTags tags={this.state.sendingToCourse}
                    suggestions={this.props.courses.map(c => {return {id: c.id, text: c.name}})}
                    handleDelete={(i) => {
                        const { sendingToCourse } = this.state;
                        this.setState({
                         sendingToCourse: sendingToCourse.filter((tag, index) => index !== i),
                        });
                        
                    }}
                    handleAddition={(tag) => {
                        this.setState(state => ({ sendingToCourse: [...state.sendingToCourse, tag] }));
                        
                    }}
                    handleDrag={(tag, currPos, newPos) => {
                        const sendingToCourse = [...this.state.sendingToCourse];
                        const newTags = sendingToCourse.slice();
                 
                        newTags.splice(currPos, 1);
                        newTags.splice(newPos, 0, tag);
                 
                        // re-render
                        this.setState({ sendingToCourse: newTags });
                    }}
                    minQueryLength={0}
                    autocomplete={true}
                    placeholder="Select courses"
                    delimiters={delimiters} />    
        )
    }
    
    renderPeopleSelector = () => {
        return (
            <ReactTags tags={this.state.sendingToPeople}
                    suggestions={this.props.users.map(u => {return {id: u.id, text: u.name + ' ' + u.lname}})}
                    handleDelete={(i) => {
                        const { sendingToPeople } = this.state;
                        this.setState({
                         sendingToPeople: sendingToPeople.filter((tag, index) => index !== i),
                        });
                        
                    }}
                    handleAddition={(tag) => {
                        this.setState(state => ({ sendingToPeople: [...state.sendingToPeople, tag] }));
                        
                    }}
                    handleDrag={(tag, currPos, newPos) => {
                        const sendingToPeople = [...this.state.sendingToPeople];
                        const newTags = sendingToPeople.slice();
                 
                        newTags.splice(currPos, 1);
                        newTags.splice(newPos, 0, tag);
                 
                        // re-render
                        this.setState({ sendingToPeople: newTags });
                    }}
                    minQueryLength={0}
                    autocomplete={true}
                    placeholder="Select people"
                    delimiters={delimiters} />   
        )
    }
    
    
    
    
    render(){
        
        const columns = [
                            {title: 'Announcement', prop: 'title', className: 'v-middle', render: this.renderAnnouncement},
                            {title: 'Date', prop: 'date', className: 'v-middle', render: this.renderDate},
                            {title: 'Type', prop: 'announcementType', className: 'v-middle'},

                            {title: 'Sent To', prop: 'users', className: 'v-middle', render: this.renderSentTo},
                            
                            {title: 'Status', prop: 'date', className: 'v-middle', render: this.renderStatus},
                            
                            
                            {title: 'Options', prop: 'id', className: 'v-middle', render: this.renderOptions},

                        ];
        
        return (
            <div className="chat-box">
                <AdminTabs view="announcements" />
                <div className="chat-contents-wrapper" style={{background: '#111', paddingBottom: '50px'}}>
                    <div className="sp-top10" style={{paddingLeft: "20px", overflowY: "scroll", position: "relative", height: "100%", paddingRight: "20px"}}>
                        <div className="flex flex-justify-content-space-between flex-align-items-center">
                            <h2 className="font-22 text-white font-300 sm-bottom30">Announcements</h2>
                            
                            <a onClick={e => {
                                e.preventDefault();
                                this.setState({createAnnouncement: true});
                                
                            }} className="btn btn-default">Create Announcement</a>
                            
                        </div>
                        
                        

                                <div className="tickets-table">
                                    {this.props.announcements.length > 0 &&
                                    
                                        buildTable(this.props.announcements, columns)
                                    }
                                </div>

                        
                    </div>
                </div>
                
                
                <div className="modal fade in" id="CreateAnnouncement" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" style={{display: (this.state.createAnnouncement) ? "block" : "none"}}>
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="close" onClick={e => {
                                e.preventDefault();
                                this.setState({createAnnouncement: false});
                                
                            }} aria-label="Close"><span aria-hidden="true">×</span></button>
                                <h4 className="modal-title" id="myModalLabel">Create an announcement</h4>
                            </div>
                            <div className="modal-body">
                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <label>Title</label>
                                            <input type="text" className="form-control" value={this.state.announcementTitle} onChange={e => this.setState({announcementTitle: e.target.value})} />
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <label>Date</label>
                                            <input type="date" className="form-control" value={this.state.announcementDate} onChange={e => this.setState({announcementDate: e.target.value})} />
                                        </div>
                                    </div>
                                </div>
                                
                                
                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="flex flex-justify-content-space-between">
                                                <label>Send to:</label>
                                                {this.state.showSendToCourse === true ?
                                                    <a href="#nogo" className="font-12" onClick={e => this.setState({showSendToPeople: true, showSendToCourse: false})}>Send To Individual Students</a>
                                                :
                                                    <a href="#nogo" className="font-12" onClick={e => this.setState({showSendToPeople: false, showSendToCourse: true})}>Send To Specific Courses</a>
                                                }
                                            </div>
                                            <div className={`course_select_list ${this.state.displaySelectOptions ? 'display-options' : ''}`}>
                                             {this.state.showSendToCourse === true ?
                                                this.renderCourseSelector()
                                            :
                                             
                                                 this.renderPeopleSelector()
                                             }
                                                
                                              
                                            </div>
                                            <div className="student_select_list" style={{display: "none"}}>
                                                <select className="chosen-select form-control" multiple="" style={{display: "none"}}>
                                                    <optgroup label="MCAT">
                                                        <option value="">Mike Taylor</option>
                                                        <option value="">Sohaib Ahmed</option>
                                                        <option value="">Shakir Shafi</option>
                                                    </optgroup>
                                                    <optgroup label="GMAT">
                                                        <option value="">Asif Ali</option>
                                                    </optgroup>
                                                    <optgroup label="LSAT">
                                                        <option value="">Shahsawawr Muhammad</option>
                                                        <option value="">Abbas</option>
                                                        <option value="">Test</option>
                                                    </optgroup>
                                                </select><div className="chosen-container chosen-container-multi" title="" style={{width: "0px"}}><ul className="chosen-choices">
                                      <li className="search-field">
                                        <input className="chosen-search-input default" type="text" autocomplete="off" value="Select Some Options" style={{width: "147px"}} />
                                      </li>
                                    </ul>
                                    <div className="chosen-drop">
                                      <ul className="chosen-results"></ul>
                                    </div></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                
                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <label>Body Text</label>
                                            <textarea className="form-control" style={{height: "100px"}} value={this.state.announcementContent} onChange={e => this.setState({announcementContent: e.target.value})}></textarea>
                                        </div>
                                    </div>
                                </div>
                
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-default" onClick={e => {
                                e.preventDefault();
                                this.setState({createAnnouncement: false});
                                
                            }}>Close</button>
                                <button type="button" className="btn btn-primary" onClick={this.sendAnnouncement}>Save changes</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            )
    }
}

export default AdminAnnouncementsView;


// WEBPACK FOOTER //
// ./src/components/Chat/AdminAnnouncementsView.js